'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var CustomRect = require('../common/CustomRect');
var styleHelper = require('../../helper/styleHelper');
var textHelper = require('../../helper/util').Text;
var propConst = require('../../constants/propConst');

/*
 * 标签输入框组件
 */
var LabelTextInput = React.createClass({

  renderContent: function (text) {
    var textArr = textHelper.delimitToParagraphs(text);
    if (textArr && textArr.length) {
      return textArr.map(function (txt, index) {
        var margin = 2;
        if (index === 0) {
          margin = 0;
        }
        txt = textHelper.convertSpaceToNbsp(txt);
        return (
          <div key={index} className="paragraph">
            <p style={{marginTop: margin}}>
              {textHelper.convertSpaceToNbsp(txt)}
            </p>
          </div>
        )
      });
    }
    return null;
  },

  render: function () {
    var text = styleHelper.getText(this.props);
    var textArray = textHelper.delimitToWords(text);
    var titleText = '';
    var contentText = '';
    if (textArray.length) {
      titleText = textArray[0];
    }
    if (textArray.length > 1) {
      contentText = text.replace(titleText + ',', '');
    }
    var backgroundStyle = {};
    var borderColor = styleHelper.getBorderColor(this.props);
    var fontColor = styleHelper.getTextColor(this.props);
    var state = styleHelper.getPropertyValue(this.props,propConst.STATUS);
    var fontSize = styleHelper.getFontSize(this.props);
    styleHelper.builderTextStyle(this.props, backgroundStyle);

    if(state === appTypes.ComStatus2.DISABLE){
      borderColor = backgroundStyle.color = '#e0e0e0';
    }
    var textColor = backgroundStyle.color;
    var titleStyle = {
      color:fontColor,
      lineHeight: Math.max(fontSize * 1.333, 24) + 'px',
      height : '100%',
      overflow:'hidden'
    };

    var contentStyle = styleHelper.StyleUtil(this.props).text().style;
    contentStyle.color = textColor;

    styleHelper.StyleUtil(this.props,titleStyle).text();

    return (<div className="contents-layout" style={{backgroundStyle}}>
      {
        this.props.textDirection === appTypes.TextDirection.LEFT
        &&
        <div ref="title" style={titleStyle} className="title">
          <label>
            {textHelper.convertSpaceToNbsp(titleText)}
          </label>
        </div>
      }

      <CustomRect ref="content" {...{
        borderColor: borderColor,
        borderStyle: styleHelper.getPropertyValue(this.props,propConst.BORDER_VISIBLE) ? 'solid' : 'none',
        backgroundColor: styleHelper.getBackgroundColor(this.props)
      }} style={{overflow: 'hidden'}}>
        <div ref="context" className="content" style={contentStyle}>
          {this.renderContent(contentText)}
        </div>
      </CustomRect>
      {
        this.props.textDirection === appTypes.TextDirection.RIGHT
        &&
        <div ref="title" style={titleStyle}>
          <label>
            {textHelper.convertSpaceToNbsp(titleText)}
          </label>
        </div>
      }
    </div>);
  },

  componentDidMount: function () {
    this.doAdjustChildBounds();
  },

  componentDidUpdate: function () {
    this.doAdjustChildBounds();
  },

  doAdjustChildBounds: function () {
    var titleDom = ReactDOM.findDOMNode(this.refs.title);
    var contentDom = ReactDOM.findDOMNode(this.refs.content);
    var contextDom = ReactDOM.findDOMNode(this.refs.context);
    var $title, $content, $context;
    var size = styleHelper.getSize(this.props);

    if (!titleDom) {
      return;
    }

    $title = $(titleDom);
    $context = $(contextDom);
    $content = $(contentDom);

    var titleW = titleDom.clientWidth;
    var contentW = size.width - titleW - 4;
    var titleH = titleDom.clientHeight;
    var contextH = contextDom.clientHeight;

    if (this.props.textDirection === appTypes.TextDirection.LEFT) {
      $title.css({left: 0});
      $content.css({left: titleW + 4, width: contentW});
    } else {
      $content.css({left: 0, width: contentW});
      $title.css({left: contentW + 4});
    }

    switch (this.props.textVAlign) {
    case appTypes.VertAlign.TOP:
      $title.css({top: 0});
      $context.css({top: 2});
      break;
    case appTypes.VertAlign.MIDDLE:
      $title.css({top: (size.height - titleH) / 2});
      $context.css({top: (size.height - contextH) / 2});
      break;
    case appTypes.VertAlign.BOTTOM:
      $title.css({top: size.height - titleH});
      $context.css({top: (size.height - contextH) - 2});
      break;
    }
  }

});

module.exports = LabelTextInput;



/** WEBPACK FOOTER **
 ** ./src/views/Components/LabelTextInput.jsx
 **/